<template>
    <div>
        <div class="__img-gallery-container1" itemscope itemtype="http://schema.org/ImageGallery">
            <template v-for="(item,index) in screenshots">
                <figure :key="index"
                        itemprop="associatedMedia"
                        itemscope
                        itemtype="http://schema.org/ImageObject">
                    <a :href="item.src" itemprop="contentUrl" :data-size="`${item.w}x${item.h}`">
                        <img :src="item.msrc" :alt="item.alt" itemprop="thumbnail"/>
                    </a>
                    <figcaption style="display: none" itemprop="caption description">{{item.title}}</figcaption>
                    <p v-if="index===0">
                        {{$t('pages.features.mapperCard.ledControllers')}}
                    </p>
                    <p v-if="index===1">
                        {{$t('pages.features.mapperCard.gap')}}
                    </p>
                    <p v-if="index===2">
                        {{$t('pages.features.mapperCard.highResolution')}}
                    </p>
                </figure>

            </template>
        </div>
        <PhotoSwipeCore/>
    </div>
</template>

<script>
    import PhotoSwipeCore from "../../../../components/Gallery/PhotoSwipeCore";

    export default {
        name: "MapperInstallationsGallery",
        components: {PhotoSwipeCore},
        mounted() {
            PhotoSwipeCore.methods.initPhotoSwipeFromDOM('.__img-gallery-container1', {
                loop: true,
                shareEl: false
            });
        },
        data() {
            return {
                screenshots: [
                    {
                        src: require("../../../../assets/pages/features/screenshots/mapper/big/installations OneB Mapper_1.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/mapper/small/installations OneB Mapper_1 prew.jpg"),
                        alt: 'picture1',
                        title: 'Image Caption 1',
                        w: 1141,
                        h: 541
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/mapper/big/installations OneB Mapper_2.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/mapper/small/installations OneB Mapper_2 prew.jpg"),
                        alt: 'picture2',
                        title: 'Image Caption 2',
                        w: 1141,
                        h: 541
                    },
                    {
                        src: require("../../../../assets/pages/features/screenshots/mapper/big/installations OneB Mapper_3.jpg"),
                        msrc: require("../../../../assets/pages/features/screenshots/mapper/small/installations OneB Mapper_3 prew.jpg"),
                        alt: 'picture3',
                        title: 'Image Caption 3',
                        w: 1141,
                        h: 541
                    }
                ]
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../../theme/theme";

    .__img-gallery-container1 {
        display: grid;
        grid-column-gap: 2rem;

        img {
            width: 100%;
            transition: all .25s;
            border: 2px solid $text20;
        }

        img:hover {
            border: 2px solid $back20;
        }

        p {
            margin-top: 0.3rem;
            margin-bottom: 0.5rem;
            font-size: 0.8em;
        }
    }

    @media (max-width: 40rem) {
        .__img-gallery-container1 {
            grid-template-columns: 1fr;
        }
    }

    @media (min-width: 40rem) and (max-width: 60rem) {
        .__img-gallery-container1 {
            grid-template-columns: repeat(2, minmax(9rem, 11rem));
        }
    }

    @media (min-width: 60rem) {
        .__img-gallery-container1 {
            grid-template-columns: repeat(3, minmax(8rem, 10rem));
        }
    }
</style>
